<template>
<div class="SelfEvaluation">
    <div class="input_box">
        <van-cell-group>
            <van-field class="Self_introduction" label="自我评价(选填)" v-model="selfInfoForm.selfevaluation" rows="14" type="textarea" maxlength="300" placeholder="请填写自我评价，最多300个字。" show-word-limit />
        </van-cell-group>
    </div>
    <div class="bottom_btn_box">
        <div @click="cancelBtn" class="cancel_btn">取消</div>
        <div @click="saveBtn" class="save_btn">保存</div>
    </div>
</div>
</template>

<script>
import {getResumBasicInfo, updateSelfevaluation} from 'api/talentApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'SelfEvaluation',
    data() {
        return {
            selfInfoForm: {
                innerid: '',
                selfevaluation: ''
            }
        }
    },
    mounted() {
        if (this.$route.query.innerid) {
            this.findResumBasicInfo()
        }
    },
    methods: {
        findResumBasicInfo() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid
            }
            getResumBasicInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.selfInfoForm.innerid = data.data.innerid
                    this.selfInfoForm.selfevaluation = data.data.selfevaluation
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        cancelBtn() {
            this.$router.back()
        },
        saveBtn() {
            var params = this.selfInfoForm
            updateSelfevaluation({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.SelfEvaluation {
    font-family:PingFangSC-Regular,PingFang SC;
    min-height: 100vh;
    padding-bottom: 2.02rem;
    box-sizing: border-box;
    background-color: #fff;
    .input_box {
        .van-cell__title {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;
            width: 100%;
        }
        .van-cell {
            display: flex;
            flex-direction: column;
            padding: 0.26rem 0.32rem;
            .van-cell__title {
                color: #666;
            }
        }
    }
    .bottom_btn_box {
        background-color: #fff;
        position: fixed;
        bottom: 0;
        width: 100vw;
        display: flex;
        justify-content: space-between;
        padding: 0 0.32rem;
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
        box-sizing: border-box;
        .cancel_btn {
            background-color: #F8F8F8;
            color: #666;
            width: 2.2rem;
            height: 0.82rem;
            line-height: 0.82rem;
            text-align: center;
            font-size: 0.32rem;
        }
        .save_btn {
            background-color: #409EFF;
            color: #FFF;
            width: 4.36rem;
            height: 0.82rem;
            line-height: 0.82rem;
            text-align: center;
            font-size: 0.32rem;
        }
    }
}
</style>